import type { PuzzleResult } from './PuzzleGenerator';

export function generateSymmetry(complexity: number, subtlety: number): PuzzleResult {
  const size = Math.min(2 + Math.floor(complexity / 2), 4);
  const colorCount = Math.min(3 + Math.floor(subtlety * 3), 6);

  // Generate a symmetric pattern (mirrored along vertical axis)
  const halfWidth = Math.ceil(size / 2);
  const reference: number[][] = [];

  for (let row = 0; row < size; row++) {
    const r: number[] = [];
    // Generate left half
    const leftHalf: number[] = [];
    for (let col = 0; col < halfWidth; col++) {
      leftHalf.push(Math.floor(Math.random() * colorCount));
    }
    // Build full row by mirroring
    for (let col = 0; col < size; col++) {
      if (col < halfWidth) {
        r.push(leftHalf[col]);
      } else {
        r.push(leftHalf[size - 1 - col]);
      }
    }
    reference.push(r);
  }

  const hasError = Math.random() < 0.75;
  let output: number[][];

  if (hasError) {
    output = reference.map(r => [...r]);
    // Break symmetry by changing one cell on one side
    const mutRow = Math.floor(Math.random() * size);
    const mutCol = Math.floor(Math.random() * halfWidth) + halfWidth;
    if (mutCol < size) {
      output[mutRow][mutCol] = (output[mutRow][mutCol] + 1) % colorCount;
    }
  } else {
    output = reference.map(r => [...r]);
  }

  return {
    reference,
    output,
    hasError,
    referenceLabel: 'Symmetric Reference',
    outputLabel: 'Agent Mirror',
  };
}
